import request from '@/utils/request'


// 查询邀请用户奖励配置列表
export function listReward(query) {
  return request({
    url: '/invite/invite-reward/list',
    method: 'get',
    params: query
  })
}

// 查询邀请用户奖励配置分页
export function pageReward(query) {
  return request({
    url: '/invite/invite-reward/page',
    method: 'get',
    params: query
  })
}

// 查询邀请用户奖励配置详细
export function getReward(data) {
  return request({
    url: '/invite/invite-reward/detail',
    method: 'get',
    params: data
  })
}

// 新增邀请用户奖励配置
export function addReward(data) {
  return request({
    url: '/invite/invite-reward/add',
    method: 'post',
    data: data
  })
}

// 修改邀请用户奖励配置
export function updateReward(data) {
  return request({
    url: '/invite/invite-reward/edit',
    method: 'post',
    data: data
  })
}

// 删除邀请用户奖励配置
export function delReward(data) {
  return request({
    url: '/invite/invite-reward/delete',
    method: 'post',
    data: data
  })
}
